import { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { InicioPage, MetabasePage, TramitacionesPage, InformesPage, MapaPrivPage, TableroPage, EstadisticasPage, AdminUserRequestsPage, ChangePasswordPage, AdminCreateProvincialUserPage, AdminUsersPage, AdminOsmPage, EntidadRequestsListPage, EntidadRequestDetailPage, EventHistoryPage } from '../pages';
//NuevaONGPage
//import { MetabasePage } from '../pages/MetabasePage';
//import { NuevaONGPage } from '../pages/NuevaONGPage';
import { LayoutPriv } from '../components/LayoutPriv';
import { AuthContext } from '../context/authContext';

export const PrivateRoutes = () => {

    const auth = useContext(AuthContext)
    const {user, role, mustChangePassword, isEspecial, userMunicipio} = useContext(AuthContext)

    // Componente para proteger rutas de admin
    const AdminRoute = ({ element }) => {
        return (role === 'admin' || user === 'Javier') ? element : <Navigate to='/inicio' replace />;
    };

    // Gestión de usuarios (admin y provincial especial)
    const UsuariosRoute = ({ element }) => {
        return (role === 'admin' || (role === 'editor_provincial' && isEspecial)) ? element : <Navigate to='/inicio' replace />;
    };

    // Administración de entidades OSM (admin, provincial especial o municipal con partido)
    const OsmAdminRoute = ({ element }) => {
        return (role === 'admin' || (role === 'editor_provincial' && isEspecial) || (role === 'editor_municipio' && !!userMunicipio)) ? element : <Navigate to='/inicio' replace />;
    };

    // Componente para proteger rutas de tablero (admin, editor_provincial o editor_municipio)
    const TableroRoute = ({ element }) => {
        return (role === 'admin' || role === 'editor_provincial' || role === 'editor_municipio') ? element : <Navigate to='/inicio' replace />;
    };

    // Componente para proteger rutas de estadísticas (mismo criterio que el tablero)
    const EstadisticasRoute = ({ element }) => {
        return (role === 'admin' || role === 'editor_provincial' || role === 'editor_municipio') ? element : <Navigate to='/inicio' replace />;
    };

    // Si el usuario debe cambiar contraseña, solo permitir acceso a esa página
    if (mustChangePassword) {
        return (
            <LayoutPriv>
                <div className="flex flex-col flex-1 bg-white dark:bg-gray-900 dark:text-white">
                    <Routes>
                        <Route path='cambiar-contraseña' element={<ChangePasswordPage />} />
                        <Route path='*' element={<Navigate to='/cambiar-contraseña' replace />} />
                    </Routes>
                </div>
            </LayoutPriv>
        );
    }

    return (
        <LayoutPriv>
            <div className="flex flex-col flex-1 h-full bg-white dark:bg-gray-900 dark:text-white">
                <Routes>
                    
                    <Route path='/inicio' element={<InicioPage />} />
                    <Route path='/metabase' element={<MetabasePage />} />
                    <Route path='/tablero' element={<TableroRoute element={<TableroPage />} />} />
                    <Route path='/estadisticas' element={<EstadisticasRoute element={<EstadisticasPage />} />} />
                   
                    <Route path='/tramitaciones' element={<TramitacionesPage />} />
                    <Route path='/informes' element={<InformesPage />} />
                    <Route path='/mapa-privado' element={<MapaPrivPage />} />
                    <Route path="/admin/solicitudes" element={<AdminRoute><AdminUserRequestsPage /></AdminRoute>} />
                    <Route path="/admin/solicitudes-usuarios" element={<AdminUserRequestsPage />} />
                    <Route path='/admin/crear-usuario-provincial' element={<AdminRoute element={<AdminCreateProvincialUserPage />} />} />
                    <Route path='/admin/usuarios' element={<UsuariosRoute element={<AdminUsersPage />} />} />
                    <Route path='/admin/osm' element={<OsmAdminRoute element={<AdminOsmPage />} />} />
                    <Route path='/admin/solicitudes-entidades' element={<EntidadRequestsListPage />} />
                    <Route path='/admin/solicitudes-entidades/:id' element={<EntidadRequestDetailPage />} />
                    <Route path='/admin/event-history' element={<AdminRoute element={<EventHistoryPage />} />} />

                    {/* si ya está logueado redirigir a inicio(priv) */}
                    <Route path='*' element={<Navigate to='/inicio' replace />} />

                </Routes>
            </div>

        </LayoutPriv>
    );
};

// <Route path='nuevaONG' element={<NuevaONGPage />} />